import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface GroupBalanceRow {
  company_id_from: string;
  company_id_to: string;
  from_name: string;
  to_name: string;
  pending_total: number;
  allocation_ids: string[];
}

export function useGroupBalance(options: { enabled?: boolean } = {}) {
  const enabled = options.enabled !== false;

  return useQuery({
    queryKey: ['group-balance'],
    queryFn: async (): Promise<GroupBalanceRow[]> => {
      const { data, error } = await (supabase as any).rpc('get_group_balance');

      if (error) throw error;

      const rows = (data ?? []) as unknown as Record<string, unknown>[];
      return rows.map((r) => ({
        company_id_from: String(r.company_id_from),
        company_id_to: String(r.company_id_to),
        from_name: String(r.from_name ?? ''),
        to_name: String(r.to_name ?? ''),
        pending_total: Number(r.pending_total ?? 0),
        allocation_ids: Array.isArray(r.allocation_ids)
          ? (r.allocation_ids as unknown[]).map((id) => String(id))
          : [],
      }));
    },
    enabled,
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
